import { FC } from 'react'

import { CA_SUBDIVISIONS } from '@/constants/regions/caSubdivisions'
import { Subdivision } from '@/types/region'

import { MultiSelectBox } from '../MultiSelectBox'

const CA_SUBDIVISIONS_LABEL = 'CA Province' as const
export const CA_SUBDIVISIONS_TEST_ID = 'ca-subdivisions-multiselect' as const

type Props = {
  value: Subdivision[]
  onChange: (value: Subdivision[]) => void
  label?: string
  testId?: string
  getOptionId?: (option: Subdivision) => string
}
export const CaSubdivisionsMultiselect: FC<Props> = ({ ...props }) => {
  return (
    <MultiSelectBox
      testId={CA_SUBDIVISIONS_TEST_ID}
      getOptionId={(option) => String(option.code)}
      label={CA_SUBDIVISIONS_LABEL}
      {...props}
      formatChipOption={(option) => option.name}
      defaultValue={undefined}
      options={CA_SUBDIVISIONS.sort((a, b) => a.name.localeCompare(b.name))}
    />
  )
}
